import { render, staticRenderFns } from "./AllNavigationPage.vue?vue&type=template&id=52dab7b7&scoped=true"
import script from "./AllNavigationPage.vue?vue&type=script&lang=js"
export * from "./AllNavigationPage.vue?vue&type=script&lang=js"
import style0 from "./AllNavigationPage.vue?vue&type=style&index=0&id=52dab7b7&prod&lang=less"
import style1 from "./AllNavigationPage.vue?vue&type=style&index=1&id=52dab7b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dab7b7",
  null
  
)

export default component.exports